<template>
  <!-- :class="[leftGp ? 'left-gp':'']" -->
  <div class="sell-wraepper" :class="[line ? 'line-height':'']">
    <!--  -->
    <div class="text-sell" :class="[size == '24' ? 'font-size-24':'font-size-26']"  @click.stop="open">即将售罄</div>
    <img :src="img + 'clicle-yellow11.png'" @click.stop="open" class="sell-wraepper-img" :class="[size == '24' ? '':'img-size-26']">

    <model-of-sell :visible.sync="bookingShow" :shorex="shorex" :showLowStock="showLowStock" :outOfStock="outOfStock"/>
  </div>
</template>

<script>
import ModelOfSell from './ModelOfLine.vue';
  export default {
    components: {
      ModelOfSell
    },

    props: {
      size: {
        type: String,
        default: '24'
      },
      shorex:{
        type: Boolean,
        default: true
      },
      showLowStock: {
        type: Boolean,
        default: true
      },
      outOfStock: {
        type: Boolean,
        default: false
      },
      leftGp: {
        type: Boolean,
        default: false
      },
      line: {
        type: Boolean,
        default: false
      },
    },

    data () {
      return {
        img:'https://resource.rcclchina.com.cn/wechatMiniProgram/routesDetail/housingSelection/',
        bookingShow:false,
        isSellOver:false
      }
    },
    methods: {
      open() {
        console.log('open')
        this.bookingShow = true;
      }
    }
  }
</script>

<style lang="less" scoped>
  .sell-wraepper {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    
  }
  .line-height{
    line-height: 1;
  }
  .sell-wraepper-img{
    width: 26px;
    height: 26px;
    margin-left: 6px;
    flex-shrink: 0;
    display: block;
  }
  .text-sell{
    color: #ff6600;
    font-size: 24px;
    font-weight: 500;
    
  }
  

  .font-size-24{ 
    font-size: 24px !important;
  }
  .font-size-26{ 
    font-size: 26px !important;
  }

  .img-size-26{
    width: 26px;
    height: 26px;
    margin-left: 6px;
    flex-shrink: 0;
    display: block;
    margin-bottom: 4px;
  }

  .left-gp{
    margin-left: 14px;
  }
</style>